import { cn } from "@/lib/utils";
import type { CSSProperties, ReactNode } from "react";

type TGlassPanelProps = {
	children: ReactNode;
	innerClassName?: string;
	contentClassName?: string;
	style?: CSSProperties;
};

export function GlassPanel({ children, innerClassName, contentClassName, style }: TGlassPanelProps) {
	return (
		<div className={cn("landing-glass-surface landing-chat-glass flex w-full flex-col", innerClassName)} style={style}>
			<div className={cn("relative z-[1] flex w-full flex-1 flex-col p-[clamp(36px,5.1vw,60px)]", contentClassName)}>
				{children}
			</div>
		</div>
	);
}
